import { ReactNode } from "react";
import remoteConfig from "@/firebase/remoteConfig";
import { getBoolean } from "firebase/remote-config";
import { Configs } from "@/constants/configs";

interface Props {
  isEnabled: Configs;
  children: ReactNode;
}

const AppConfig = ({ children, isEnabled: featureFlag }: Props) => {
  if (getBoolean(remoteConfig, featureFlag)) {
    return children;
  }

  return null;
};

export default AppConfig;
